import { z } from 'zod'

export const URLRequestSchema = z.object({
  path: z.string(),
  basePath: z.string().optional(),
  headers: z.record(z.string(), z.string()),
  method: z.string(),
})

export type URLRequest = z.infer<typeof URLRequestSchema>